var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.maintenance && _vm.maintenance.status === 'on' )?_c('div',{staticStyle:{"white-space":"pre-wrap","height":"100vh"}},[_vm._v(" "+_vm._s(_vm.maintenance.body)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }